module.exports = __webpack_public_path__ + "img/ypo-renewals-stage-2.f2973997.png";